// eslint-disable-next-line no-restricted-exports
export { default } from './artboard';
export { default as artboardConfig } from './artboard.config';
